import { render, staticRenderFns } from "./SelectRestaurant.vue?vue&type=template&id=10f18b3a&"
import script from "./SelectRestaurant.vue?vue&type=script&lang=js&"
export * from "./SelectRestaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports